/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Test_FailedInputs */

const th_test_failed = /** @type {(inputs: Test_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ส่งคำขอไม่สำเร็จ หากคุณออกจากระบบไปแล้ว กรุณาเข้าสู่ระบบแล้วลองอีกครั้ง`)
};

const en_test_failed = /** @type {(inputs: Test_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The request did not get through. If you have been signed out, sign in and try again.`)
};

const ja_test_failed = /** @type {(inputs: Test_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リクエストが通りませんでした。サインアウトされている場合は、サインインしてからもう一度お試しください。`)
};

const zh_test_failed = /** @type {(inputs: Test_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请求未能送达。若你被登出，请登录后重试。`)
};

const es_test_failed = /** @type {(inputs: Test_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La solicitud no ha llegado. Si se ha cerrado tu sesión, inicia sesión e inténtalo de nuevo.`)
};

const pt_test_failed = /** @type {(inputs: Test_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A solicitação não chegou. Se sua sessão caiu, entre de novo e tente outra vez.`)
};

const id_test_failed = /** @type {(inputs: Test_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permintaan tidak sampai. Jika Anda keluar, masuk lalu coba lagi.`)
};

const fr_test_failed = /** @type {(inputs: Test_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La requête n’est pas passée. Si vous avez été déconnecté, reconnectez-vous et réessayez.`)
};

const tl_test_failed = /** @type {(inputs: Test_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi nakalusot ang kahilingan. Kung na-sign out ka, mag-sign in at subukang muli.`)
};

const vi_test_failed = /** @type {(inputs: Test_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yêu cầu không đi được. Nếu bạn bị đăng xuất, hãy đăng nhập rồi thử lại.`)
};

const ko_test_failed = /** @type {(inputs: Test_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`요청이 전달되지 않았습니다. 로그아웃되었다면 로그인한 뒤 다시 시도하세요.`)
};

const de_test_failed = /** @type {(inputs: Test_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Anfrage kam nicht durch. Falls du abgemeldet wurdest, melde dich an und versuche es erneut.`)
};

const ru_test_failed = /** @type {(inputs: Test_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запрос не прошёл. Если вас разлогинило, войдите и попробуйте снова.`)
};

const tr_test_failed = /** @type {(inputs: Test_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İstek ulaşmadı. Oturumunuz kapandıysa giriş yapıp yeniden deneyin.`)
};

const it_test_failed = /** @type {(inputs: Test_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La richiesta non è andata a buon fine. Se sei stato disconnesso, accedi e riprova.`)
};

const pl_test_failed = /** @type {(inputs: Test_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Żądanie nie dotarło. Jeśli cię wylogowało, zaloguj się i spróbuj ponownie.`)
};

const uk_test_failed = /** @type {(inputs: Test_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запит не пройшов. Якщо вас розлогінило, увійдіть і спробуйте ще раз.`)
};

const hi_test_failed = /** @type {(inputs: Test_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुरोध नहीं पहुँचा। अगर आप साइन आउट हो गए हों, तो साइन इन करके फिर कोशिश करें।`)
};

const ar_test_failed = /** @type {(inputs: Test_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يصل الطلب. إن خرجت من حسابك، سجّل الدخول وأعد المحاولة.`)
};

const ms_test_failed = /** @type {(inputs: Test_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permintaan tidak sampai. Jika anda dilog keluar, log masuk dan cuba lagi.`)
};

const bn_test_failed = /** @type {(inputs: Test_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অনুরোধ পৌঁছায়নি। সাইন আউট হয়ে থাকলে সাইন ইন করে আবার চেষ্টা করুন।`)
};

const zh_tw2_test_failed = /** @type {(inputs: Test_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`請求未能送達。若你被登出，請登入後再試。`)
};

const zh_hk2_test_failed = /** @type {(inputs: Test_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`請求未能送達。若你被登出，請登入後再試。`)
};

const ur_test_failed = /** @type {(inputs: Test_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`درخواست نہیں پہنچی۔ اگر آپ سائن آؤٹ ہو گئے ہوں تو سائن اِن کر کے دوبارہ کوشش کریں۔`)
};

const fa_test_failed = /** @type {(inputs: Test_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`درخواست نرسید. اگر از حساب خارج شده‌اید، وارد شوید و دوباره تلاش کنید.`)
};

const sw_test_failed = /** @type {(inputs: Test_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ombi halikufika. Kama umetolewa, ingia kisha ujaribu tena.`)
};

const nl_test_failed = /** @type {(inputs: Test_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het verzoek is niet aangekomen. Als je bent uitgelogd, log dan in en probeer opnieuw.`)
};

/**
* | output |
* | --- |
* | "The request did not get through. If you have been signed out, sign in and try again." |
*
* @param {Test_FailedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const test_failed = /** @type {((inputs?: Test_FailedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Test_FailedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_test_failed(inputs)
	if (locale === "ja") return ja_test_failed(inputs)
	if (locale === "zh") return zh_test_failed(inputs)
	if (locale === "es") return es_test_failed(inputs)
	if (locale === "pt") return pt_test_failed(inputs)
	if (locale === "id") return id_test_failed(inputs)
	if (locale === "fr") return fr_test_failed(inputs)
	if (locale === "tl") return tl_test_failed(inputs)
	if (locale === "vi") return vi_test_failed(inputs)
	if (locale === "ko") return ko_test_failed(inputs)
	if (locale === "de") return de_test_failed(inputs)
	if (locale === "ru") return ru_test_failed(inputs)
	if (locale === "tr") return tr_test_failed(inputs)
	if (locale === "it") return it_test_failed(inputs)
	if (locale === "pl") return pl_test_failed(inputs)
	if (locale === "uk") return uk_test_failed(inputs)
	if (locale === "hi") return hi_test_failed(inputs)
	if (locale === "ar") return ar_test_failed(inputs)
	if (locale === "ms") return ms_test_failed(inputs)
	if (locale === "bn") return bn_test_failed(inputs)
	if (locale === "zh-TW") return zh_tw2_test_failed(inputs)
	if (locale === "zh-HK") return zh_hk2_test_failed(inputs)
	if (locale === "ur") return ur_test_failed(inputs)
	if (locale === "fa") return fa_test_failed(inputs)
	if (locale === "sw") return sw_test_failed(inputs)
	if (locale === "nl") return nl_test_failed(inputs)
	return en_test_failed(inputs)
});